import { Box, Center, Flex } from "@chakra-ui/react";
import { AiOutlineCalculator as Calculation } from "react-icons/ai";
import { FaGears as Gears } from "react-icons/fa6";
import { GiPositionMarker as Marker } from "react-icons/gi";

export function StepDisplay({ step }: { step: number }) {
  const primary = "brand.primary";
  const secondary = "brand.secondary";

  return (
    <Flex
      position="fixed"
      insetBlockStart="50%"
      insetInlineStart="50%"
      transform="translate(-50%, -50%)"
      bg="white"
      p={4}
      alignItems="center"
      flexDirection="column"
      zIndex={100}
      border="2px solid"
      borderColor="brand.primary"
    >
      <Center w={16} h={16} bg={step < 1 ? secondary : primary} fontSize={32} color="white">
        <Marker />
      </Center>
      <Box w={3} h={8} bg={step < 2 ? secondary : primary}></Box>
      <Center
        w={16}
        h={16}
        bg={step < 2 ? secondary : primary}
        fontSize={32}
        color={step < 2 ? primary : "white"}
      >
        <Gears />
      </Center>
      <Box w={3} h={8} bg={step < 3 ? secondary : primary}></Box>
      <Center w={16} h={16} bg={step < 3 ? secondary : primary} fontSize={32} color={primary}>
        <Calculation />
      </Center>
    </Flex>
  );
}
